<template>
	<v-layout v-if="wasModified() || !isOld || !otherCost">
		<v-flex d-flex xs4>
			<v-card :color="(actionNamesDifferent() ? color() : 'grey') + ' lighten-3'">
				<v-layout row wrap align-center>
					<v-container>
						<strong>
							{{actionName}} &emsp;{{status()}}
						</strong>
					</v-container>
				</v-layout>
			</v-card>
		</v-flex>
		<v-flex d-flex xs2>
			<v-card :color="(mszFundingsDifferent() ? color() : 'grey') + ' lighten-3'">
				<div class="ma-2">
					<egranty-number-input-field
						:disabled="true"
						v-model="cost.mszFundings"
						:label="currency.code === '' ? 'kwota w PLN' : 'kwota w ' + currency.code"

					/>
				</div>
			</v-card>
		</v-flex>
		<v-flex d-flex xs2>
			<v-card :color="(paragraphsDifferent() ? color() : 'grey') + ' lighten-3'" width="100%">
				<v-container>
					<strong>
						{{paragraphName}}
					</strong>
				</v-container>
			</v-card>
		</v-flex>
		<v-flex d-flex xs2>
			<v-card :color="(ownFundingsDifferent() ? color() : 'grey') + ' lighten-3'">
				<div class="ma-2">

					<egranty-number-input-field
						:disabled="true"
						v-model="cost.ownFundings"
						:label="currency.code === '' ? 'kwota w PLN' : 'kwota w ' + currency.code"

					/>
				</div>
			</v-card>
		</v-flex>
		<v-flex d-flex xs2>
			<v-card :color="(mszFundingsDifferent() || ownFundingsDifferent() ? color() : 'grey') + ' lighten-3'">
				<div class="ma-2">
					<v-container style="padding-left: 0">
						<strong>
							{{formatMoney(Number.parseFloat(cost.ownFundings) + Number.parseFloat(cost.mszFundings))}}
						</strong>
					</v-container>
				</div>
			</v-card>
		</v-flex>
	</v-layout>
</template>

<script>
	import {Numbers} from "../../../../utils/Numbers";
	import EgrantyNumberInputField from "../../../../genericComponents/EgrantyNumberInputField";

	export default {
		name: "AgencySingleCost",
		components: {EgrantyNumberInputField},
		props: {
			actionName: {},
			paragraphName: {},
			cost: {},
			otherCost: {},
			isOld: {},
			currency: {}
		},
		mixins: [Numbers],

		methods: {

			propertiesDifferent(getter) {
				if (!this.otherCost) {
					return true;
				}
				return getter(this.otherCost) !== getter(this.cost);
			},

			status() {
				if (!this.otherCost) {
					return this.isOld ? '(Usunięty)' : '(Nowy)';
				}
				return this.wasModified() ? (this.isOld ? "(Było)" : "(Jest)") : '';
			},

			wasModified() {
				if (!this.otherCost) {
					return false;
				}
				return this.mszFundingsDifferent() || this.ownFundingsDifferent();
			},

			paragraphsDifferent() {
				return this.propertiesDifferent(x => x.paragraphId);
			},

			actionNamesDifferent() {
				return this.propertiesDifferent(x => x.paragraphId);
			},

			mszFundingsDifferent() {
				return this.propertiesDifferent(x => x.mszFundings);
			},

			ownFundingsDifferent() {
				return this.propertiesDifferent(x => x.ownFundings);
			},

			color () {
				if (!this.otherCost) {
					return this.isOld ? 'red' : 'green';
				}
				return this.wasModified() ? "blue" : "gray";
			}
		}
	};
</script>

<style scoped>

</style>